import { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import DashboardLayout from "@/components/DashboardLayout";
import { Empty } from "@/components/Shared";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Notifications() {
    const [items, setItems] = useState(null);

    const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => setItems([]));
    useEffect(() => { load(); }, []);

    const markAll = async () => {
        await api.post("/notifications/read-all");
        load();
    };

    return (
        <DashboardLayout title="Notifications">
            <div className="mx-auto max-w-3xl" data-testid="notifications-page">
                <div className="flex items-center justify-between">
                    <h1 className="font-display text-2xl font-bold tracking-tight">Notifications</h1>
                    <Button data-testid="mark-all-read-button" size="sm" variant="outline" className="rounded-full" onClick={markAll}>
                        <CheckCheck className="mr-1 h-4 w-4" /> Mark all read
                    </Button>
                </div>
                {items === null ? <p className="mt-8 text-sm text-muted-foreground">Loading...</p>
                : items.length === 0 ? <div className="mt-8"><Empty icon={Bell} title="No notifications yet" hint="Application updates, matching opportunities and certificate alerts will appear here." /></div>
                : (
                    <div className="mt-6 space-y-3">
                        {items.map((n) => (
                            <Link key={n.id} to={n.link || "#"} data-testid={`notification-${n.id}`}
                                className={`card-soft flex items-start gap-4 p-5 transition-colors duration-200 ${n.read ? "opacity-70" : "border-primary/30"}`}>
                                <span className={`mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full ${n.read ? "bg-muted" : "bg-primary/10"}`}>
                                    <Bell className={`h-4 w-4 ${n.read ? "text-muted-foreground" : "text-primary"}`} />
                                </span>
                                <div>
                                    <p className="text-sm">{n.text}</p>
                                    <p className="mt-1 text-xs text-muted-foreground">{new Date(n.created_at).toLocaleString()}</p>
                                </div>
                                {!n.read && <span className="ml-auto mt-2 h-2 w-2 shrink-0 rounded-full bg-accent" />}
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </DashboardLayout>
    );
}
